module.exports = __webpack_public_path__ + "static/media/electronics-cat-menu-img.6af4b0e6.png";